module.exports = __webpack_public_path__ + "static/Information-1e5da9766308b774dab89903dd120540.svg";